import { useCallback, useState } from 'react';
import { fetchEvents } from '../utils/fetchEvents';
import { groupConfig } from '../config/groupConfig';

const useFetchEvents = (setRows, setFilteredRows, setSearchInitiated) => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setSearchInitiated(true);
    setLoading(true);
    setLoadingProgress(0);

    const groupAliasIDs = groupConfig.groups.map(group => group.id);
    const totalSteps = groupAliasIDs.length * 2; // Each API: request sent + response received
    let currentStep = 0;

    // Patch fetchEvents to accept progress callback
    const fetchEventsWithProgress = async (ids, onProgress) => {
      // Array of promises, each increments progress on send and receive
      const promises = ids.map(async (id) => {
        onProgress(); // Request sent
        try {
          const result = await fetchEvents([id]);
          onProgress(); // Response received
          return result;
        } catch (e) {
          onProgress(); // Still increment on error
          throw e;
        }
      });
      // Wait for all and flatten
      const results = await Promise.all(promises);
      return results.flat();
    };

    try {
      const sortedData = await fetchEventsWithProgress(groupAliasIDs, () => {
        currentStep += 1;
        setLoadingProgress(Math.min(100, (currentStep / totalSteps) * 100));
      });
      setRows(sortedData);
      setFilteredRows(sortedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
      setLoadingProgress(100);
    }
  }, [setRows, setFilteredRows, setSearchInitiated]);

  return { fetchData, loading, loadingProgress };
};

export default useFetchEvents;
